
export interface StaffBarHeadersParsed {
  requestId?: string
  token?: string 
  enhancements: string[]
}

export const StaffBarHeaders = {
  requestId: 'X-StaffBar-Request-Id',
  token: 'X-StaffBar-Token',
  enhancements: 'X-StaffBar-Enhancements',
}

export const StaffBarURLPrefix = '/_staffbar'
